// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"253":"74402cb2","314":"d6d255ed","535":"5ba2a17e"}[chunkId] + ".chunk.js";
};